import { z } from 'zod'

// Fail fast at boot with a message that names exactly what is missing, rather
// than shipping a blank screen and a console error nobody reads. Only the two
// variables every product needs; a product validates its own extras.
const envSchema = z.object({
  VITE_PUBLIC_SUPABASE_URL: z.string().url(),
  VITE_PUBLIC_SUPABASE_ANON_KEY: z.string().min(1),
})

const parsed = envSchema.safeParse(import.meta.env)
if (!parsed.success) {
  const issues = parsed.error.issues.map((i) => `  - ${i.path.join('.')}: ${i.message}`).join('\n')
  throw new Error(
    `Invalid client env. Copy .env.example to .env at the repo root and fill in:\n${issues}`,
  )
}

export const env = parsed.data
